module.exports = __webpack_public_path__ + "img/wbc-banner.90f1eb6c.jpg";